import home from './navs/home';
import center from './navs/center';
import report from './navs/report.js';
import questionnaire from './navs/questionnaire';

export default {
  home,
  center,
  report,
  questionnaire,
  homeCode: 'gwnl_eval_index',
  centerCode: 'gwnl_eval_center',
  reportCode: 'gwnl_eval_report',
  questionnaireCode: 'gwnl_eval_questionnaire'
};
